import { Overlay } from "@angular/cdk/overlay";
import {
  Component,
  effect,
  ElementRef,
  input,
  output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { CustomSelectOverlay } from "./nsdc-custom-select-overlay";
import { asyncScheduler } from "rxjs";
import { MatSelectModule } from "@angular/material/select";

@Component({
  selector: "app-naps-select-box",
  standalone: true,
  templateUrl: "./nsdc-select-box.component.html",
  styleUrl: "./nsdc-select-box.component.scss",
  imports:[MatSelectModule,ReactiveFormsModule],
  viewProviders: [
    {
      provide: Overlay,
      useClass: CustomSelectOverlay,
    },
  ],
})
export class NsdcSelectBoxComponent {
  customFormControl = input<FormControl>(new FormControl(""));
  label = input<string>("");
  placeholder = input<string>("");
  isRequired = input<boolean>(false);
  errorMessage = input<string>("");
  ariaLabel = input<string>("");
  disabledField = input<boolean>(false);
  isMultiSelect = input<boolean>(false);
  canSelectNullableOptions = input<boolean>(false);
  infoMessage = input<string|undefined>(undefined);
  
  options = input<{ label: string; value: string }[]>([]);
  labelKey = input<string>("label");
  valueKey = input<string>("value");
  returnEntireObject = input<boolean>(false);
  showFirstOption = input<boolean>(true);

  width=input<string>('');

  binCurrentLineIdWithValue = input<boolean>(false);
  lineId = input<string>("");

  optionChanged = output<string>();

  previousMarginleft: number = 0;
  @ViewChild("selectRef", { read: ElementRef }) selectRef!: ElementRef;

  constructor(private renderer: Renderer2) {
    effect(() => {
      const control = this.customFormControl();
      if (!control) return;

      if (this.disabledField()) {
        control.disable({ emitEvent: false });
      } else {
        control.enable({ emitEvent: false });
      }
    });
  }

  onOpenedChange(isOpen: boolean): void {
    if (isOpen) {
      asyncScheduler.schedule(() => {
        const selectEl = this.selectRef.nativeElement;
        const selectRect = selectEl.getBoundingClientRect();
        const overlayPanel = document.querySelector(
          ".custom-select-overlay-panel"
        ) as HTMLElement;

        if (overlayPanel) {
          const overlayRect = overlayPanel.getBoundingClientRect();

          const offsetLeft = selectRect.left - overlayRect.left;
          if (offsetLeft !== 0) this.previousMarginleft = offsetLeft;
          const marginfromLeft = offsetLeft
            ? offsetLeft
            : this.previousMarginleft;
          // Use center-point comparison
          const selectCenter = (selectRect.top + selectRect.bottom) / 2;
          const overlayCenter = (overlayRect.top + overlayRect.bottom) / 2;

          const isOverlayBelow = overlayCenter > selectCenter;

          this.renderer.removeStyle(overlayPanel, "margin-top");
          this.renderer.removeStyle(overlayPanel, "margin-bottom");
          this.renderer.removeStyle(overlayPanel, "margin-left");
          if (isOverlayBelow) {
            this.renderer.setStyle(overlayPanel, "margin-top", `14px`);
            this.renderer.setStyle(
              overlayPanel,
              "margin-left",
              `${marginfromLeft}px`
            );
          } else {
            this.renderer.setStyle(overlayPanel, "margin-bottom", `14px`);
            this.renderer.setStyle(
              overlayPanel,
              "margin-left",
              `${marginfromLeft}px`
            );
          }
        }
      });
    }
  }

  emitValueOnOptionChange(event: any) {
    this.customFormControl().setValue(event);
    this.optionChanged.emit(event);
  }
}
